import { combineReducers } from 'redux';

import { experimentsTableDataReducer, experimentsTableFilterOptionReducer } from './indexPage';

export const experimentsIndexReducer = combineReducers({
  tableData: experimentsTableDataReducer,
  tableFilterOption: experimentsTableFilterOptionReducer,
});
